module.exports = "mutation rematch($rematchInput:RematchInput!){rematch(rematchInput:$rematchInput)}"